import ResendWelcomeEmail from "./resend-welcome-email";

export default ResendWelcomeEmail;
